<template>
  <span :style="{color:currColor,fontSize:defaultStyle['fontSize']}">{{font}}</span>
</template>

<script>
  export default {
    data(){
      return{
        spanStyle:{
          transparent:'transparent',
          white:'#fff',
          blue:'#00c0ff',
          orange:'#ff8800',
          red: '#f46471'
        },
        currColor:'',
        defaultStyle:{fontSize:'1.4rem'},
      }
    },
    props:{
      font: {
        type: String,
        default: '保存'
      },
      type: {
        type: String,
        default: 'blue'
      },
    },
    mounted(){
      this.currColor = this.spanStyle[this.type]

    },
    methods:{

    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/commons/Xspan.vue